const SoundOffIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Base speaker + waves (same as SoundIcon) */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.126 4.891a.484.484 0 0 0-.683 0 .48.48 0 0 0 0 .681 6.25 6.25 0 0 1 0 8.855.48.48 0 0 0 0 .682.484.484 0 0 0 .683 0A7.2 7.2 0 0 0 17.25 10a7.2 7.2 0 0 0-2.123-5.109m-2.389 2.38a.484.484 0 0 0-.683 0 .48.48 0 0 0 0 .682 2.886 2.886 0 0 1 0 4.087.48.48 0 0 0 0 .681.484.484 0 0 0 .683 0 3.847 3.847 0 0 0 0-5.45M9.807 5.28a.482.482 0 0 0-.786-.376L5.77 7.495H3.232a.483.483 0 0 0-.483.482v4.046c0 .266.217.482.483.482H5.77l3.251 2.592a.485.485 0 0 0 .785-.376zM6.24 8.353l2.6-2.073v7.438l-2.6-2.071a.5.5 0 0 0-.302-.105H3.716V8.458h2.223c.11 0 .217-.037.302-.105"
      fill="currentColor"
    />
    {/* Diagonal slash */}
    <line
      x1="4"
      y1="16"
      x2="16"
      y2="4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
export default SoundOffIcon;